
import { get, post } from './http'

const base = '/operate/frontend/sticker/packs'
const emoji = {
  getSeriesEmojiList: () => {
    return get(`${base}/gets`)
  },
}
export default emoji


